import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { ProductsService } from 'src/app/shared/services/products.service';

@UntilDestroy()
@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrl: './products-list.component.scss'
})
export class ProductsListComponent {
  allProducts:any;
  filteredProducts:any;
  searchProducts: FormGroup;
  searchCtrl = new UntypedFormControl();
  selectedProduct:any;

  constructor(public dialogRef: MatDialogRef<ProductsListComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: {productsList:any[],productId:any},
    private productsService:ProductsService,
    private translationService:TranslateService,
    private fb: FormBuilder,
  ){
this.allProducts=data.productsList;
this.filteredProducts=this.allProducts;
this.selectedProduct=data.productId;
  }

  ngOnInit() {
    this.searchProducts = this.fb.group({
      selectedValue:[this.selectedProduct?this.filteredProducts.find(prod=>prod.id==this.selectedProduct):null,Validators.required]
    })
this.searchCtrl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((value) => this.onFilterChange(value));
  }

  onFilterChange(value: string) {  
    // Ensure `allproducts` is available
    if (!this.allProducts || this.allProducts.length === 0) {
      this.filteredProducts = [];
      return;
    }
  
    // Clean and validate input
    value = value?.trim().toLowerCase(); 
  
    // If input is empty, reset to show all products
    if (!value) {
      this.filteredProducts = [...this.allProducts];
      return;
    }
  
    // Filter by both Name and Code (case-insensitive, alphanumeric support)
    this.filteredProducts = this.allProducts.filter((product: any) => {
      //// // debugger;
      const name = product?.name.toLowerCase() || '';
      const code = product?.code || '';
  
      return name.includes(value) || code.includes(value);
    });
  }

  onSubmit(){
    //// // debugger;
    if(this.searchProducts.invalid){
      return;
    }
    this.dialogRef.close(this.searchProducts.value.selectedValue);

  }
  onCancel(): void {
    this.dialogRef.close();
  }
}
